module.exports = __webpack_public_path__ + "media/application/images/2018/font-weight-dif-9845c575b26aca49549c8f0b42f4b18d.png";